export default __webpack_public_path__ + "static/media/storagebg.5b8ba968.png";